import { Currency } from "../i18n/Currency";
import { WeightedValue } from "../shared/WeightedValue";
import { WeightedEstimates } from "./general/WeightedEstimates";
import { WeightedValueEditor } from "./WeightedValueEditor";

export const WeightedValuesEditor = ({
  values,
  onChange,
  currency,
  min,
  max,
}: {
  values: WeightedValue[];
  onChange: (newValues: WeightedValue[]) => void;
  currency: Currency;
  min?: number;
  max?: number;
}) => {
  let totalWeight = 0;
  let sum = 0;
  values.forEach((value) => {
    totalWeight += value.weight;
    sum += value.value * value.weight;
  });
  const showWeights = values.length > 1;

  return (
    <WeightedEstimates
      kind="weightedValue"
      showWeights={showWeights}
      // a single estimate is the value itself
      result={
        showWeights && totalWeight > 0
          ? currency.format(sum / totalWeight)
          : undefined
      }
      onAdd={() => onChange(values.concat({ value: 0, weight: 1 }))}
    >
      {values.map((value, index) => {
        const share = totalWeight > 0 ? value.weight / totalWeight : undefined;
        return (
          <WeightedValueEditor
            key={"weighted-value-" + index}
            {...value}
            weight={showWeights ? value.weight : undefined}
            currency={currency}
            share={share}
            onValueChange={(newValue) =>
              onChange(
                values.map((v) =>
                  v === value ? { ...value, value: newValue } : v,
                ),
              )
            }
            onWeightChange={(newWeight) =>
              onChange(
                values.map((v) =>
                  v === value ? { ...value, weight: newWeight } : v,
                ),
              )
            }
            onDelete={
              values.length > 1
                ? () => onChange(values.filter((v) => v !== value))
                : undefined
            }
            min={min}
            max={max}
          />
        );
      })}
    </WeightedEstimates>
  );
};
